module.exports = __webpack_public_path__ + "static/img/certidoes_de_nascimento_casamento.6670f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certidoes_de_nascimento_casamento.png
// module id = qS97
// module chunks = 1